export default function RedCheckIcon() {
  return (
    <>
      <path
        d='M22.5001 40.3327C32.6253 40.3327 40.8334 32.1246 40.8334 21.9993C40.8334 11.8741 32.6253 3.66602 22.5001 3.66602C12.3749 3.66602 4.16675 11.8741 4.16675 21.9993C4.16675 32.1246 12.3749 40.3327 22.5001 40.3327Z'
        fill='#A0383F'
      />
      <path
        d='M19.8966 28.5642C19.53 28.5642 19.1816 28.4176 18.925 28.1609L13.7366 22.9726C13.205 22.4409 13.205 21.5609 13.7366 21.0292C14.2683 20.4976 15.1483 20.4976 15.68 21.0292L19.8966 25.2459L29.32 15.8226C29.8516 15.2909 30.7316 15.2909 31.2633 15.8226C31.795 16.3542 31.795 17.2342 31.2633 17.7659L20.8683 28.1609C20.6116 28.4176 20.2633 28.5642 19.8966 28.5642Z'
        fill='white'
      />
    </>
  );
}
